import { useEffect } from "react";

const upsertMeta = (key, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const SITE = "https://tuningfiles.hu";

/**
 * Sets document title, meta description/keywords, canonical, OG tags and an
 * optional JSON-LD block for the current page. Reacts to language changes.
 */
const Seo = ({ title, description, keywords, path = "/", jsonLd = null }) => {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("description", description);
    upsertMeta("keywords", keywords);
    upsertMeta("og:title", title, "property");
    upsertMeta("og:description", description, "property");
    upsertMeta("og:url", `${SITE}${path}`, "property");
    upsertMeta("twitter:title", title);
    upsertMeta("twitter:description", description);
    upsertLink("canonical", `${SITE}${path}`);

    const id = "page-jsonld";
    let script = document.getElementById(id);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = id;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, [title, description, keywords, path, jsonLd]);

  return null;
};

export default Seo;
